import styled from 'styled-components';
import { LabelRegularBoldM } from '../../../styles/globals';
import Icon from '@/assets/icons/filterIcon.svg?react';

export const NAME_CELL_WIDTH = '25.5%';
export const PHONE_CELL_WIDTH = '15%';
export const LANGUAGE_CELL_WIDTH = '15%';
export const TEAM_CELL_WIDTH = '17.5%';
export const LEADER_CELL_WIDTH = '15%';
export const ROLE_CELL_WIDTH = '14%';
export const REPORT_CELL_WIDTH = '17.5%';
export const STATUS_CELL_WIDTH = '10%';

export const TableHeaderCont = styled.div`
  display: flex;
  height: 48px;
  align-items: center;

  ${({ theme }) => `
    margin: ${theme.layout.spacing.centy} ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.centy};
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.deka};
    gap: ${theme.layout.spacing.mikro};
  `}
`;

export const Column = styled(LabelRegularBoldM)`
  display: block;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const NameColumn = styled(Column)`
  width: ${NAME_CELL_WIDTH};
`;

export const PhoneColumn = styled(Column)`
  width: ${PHONE_CELL_WIDTH};
`;

export const StatusColumn = styled(Column)`
  width: ${STATUS_CELL_WIDTH};
`;

export const LanguageColumn = styled(Column)`
  width: ${LANGUAGE_CELL_WIDTH};

  a {
    margin: 0 3px;
  }
`;

export const FilterIcon = styled(Icon)`
  margin-left: 5px;
  width: 18px;
  height: 11px;
`;

export const FilteredLanguagesNumber = styled.span`
  ${({ theme }) => `
    color: ${theme.colors.secondary[100]};
  `}
`;

export const TeamColumn = styled(Column)`
  width: ${TEAM_CELL_WIDTH};
`;

export const LeaderColumn = styled(Column)`
  width: ${LEADER_CELL_WIDTH};
`;

export const RoleColumn = styled(Column)`
  width: ${ROLE_CELL_WIDTH};
`;

export const ReportColumn = styled(Column)`
  width: ${REPORT_CELL_WIDTH};
`;

export const LegendCont = styled.div`
  ${({ theme }) => `
    margin: 0 ${theme.layout.spacing.centy} 0;
  `}
`;
